const Bell = () => (
  <>
    <path
      fill="currentColor"
      d="M5.5 18.27a.48.48 0 0 1-.356-.145.49.49 0 0 1-.144-.357q0-.212.144-.355a.49.49 0 0 1 .356-.144h1.116v-6.923q0-1.959 1.24-3.447A5.27 5.27 0 0 1 11 5.046V4.5q0-.417.291-.708a.96.96 0 0 1 .707-.292q.415 0 .709.292.293.291.293.708v.546A5.27 5.27 0 0 1 16.144 6.9q1.24 1.487 1.24 3.447v6.923H18.5q.212 0 .356.144a.48.48 0 0 1 .144.357q0 .212-.144.356a.48.48 0 0 1-.356.143zm6.496 2.614a1.55 1.55 0 0 1-1.14-.474 1.56 1.56 0 0 1-.472-1.14h3.232q-.001.67-.476 1.143a1.56 1.56 0 0 1-1.144.471m-4.38-3.615h8.769v-6.923q0-1.823-1.281-3.104-1.281-1.28-3.104-1.28t-3.104 1.28-1.28 3.104z"
    />
  </>
)
export default Bell
